// extracted by mini-css-extract-plugin
export default {"quiz":"quiz_quiz__GDYYj","container":"quiz_container__Tsi2W","loader":"quiz_loader__p9fWX","content":"quiz_content__ORccU"};